import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/highlights.scss';

import highlight1 from '../assets/images/image1.png';
import highlight2 from '../assets/images/image2.png';
import highlight3 from '../assets/images/image3cc.png';
import highlight4 from '../assets/images/image4.png';
import highlight5 from '../assets/images/image5.png';
import leftArrow from '../assets/svg/left.svg';
import rightArrow from '../assets/svg/right.svg';

const Highlights = () => {
  const { t } = useTranslation();
  const scrollRef = useRef(null);

  const highlightCards = [
    {
      image: highlight1,
      title: t('highlights.card1_title'),
      caption: t('highlights.card1_caption'),
      alt: 'Monochrome collaboration interface mockup with a page layout preview on the left and chat-style feedback bubbles on the right, representing Yves Web Design\'s client review process.'
    },
    {
      image: highlight2,
      title: t('highlights.card2_title'),
      caption: t('highlights.card2_caption'),
      alt: 'Dark performance dashboard UI showing an overall score of 93 with separate cards for speed, SEO and stability metrics, visualising how Yves Web Design tracks website quality.'
    },
    {
      image: highlight3,
      title: t('highlights.card3_title'),
      caption: t('highlights.card3_caption'),
      alt: 'Monochrome illustration of a laptop, tablet and smartphone showing the same website layout, highlighting Yves Web Design\'s focus on responsive web design.'
    },
    {
      image: highlight4,
      title: t('highlights.card4_title'),
      caption: t('highlights.card4_caption'),
      alt: 'Dark UI timeline with rounded stages labeled discovery, design, development and an in progress tag, reflecting Yves Web Design\'s structured project workflow.'
    },
    {
      image: highlight5,
      title: t('highlights.card5_title'),
      caption: t('highlights.card5_caption'),
      alt: 'Monochrome browser window mockup showing a simple hero section with a heading, subheading and call to action button, representing Yves Web Design\'s landing page design.'
    }
  ];

  const handleScroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    const firstCard = el.querySelector('.highlight-card');
    if (!firstCard) return;

    const styles = window.getComputedStyle(el);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const cardWidth = firstCard.getBoundingClientRect().width;

    const step = Math.round(cardWidth + gap);
    el.scrollBy({
      left: direction === 'next' ? step : -step,
      behavior: 'smooth',
    });
  };

  return (
    <section className="highlights" id="case-studies">
      <div className="section-shell highlights__introRow">
        <div className="highlights__intro">
          <div>
            <p className="highlights__label">{t('highlights.label')}</p>
            <h2>
              {t('highlights.title')}
            </h2>
          </div>
          <div className="highlights__controls" aria-label="slide controls">
            <button type="button" aria-label="Previous slide" onClick={() => handleScroll('prev')}>
              <img src={leftArrow} alt="" aria-hidden="true" />
            </button>
            <button type="button" aria-label="Next slide" onClick={() => handleScroll('next')}>
              <img src={rightArrow} alt="" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <div className="highlights__rail">
        <div
          className="highlights__cards"
          ref={scrollRef}
          role="region"
          aria-label="Highlights carousel"
          tabIndex={0}
        >
          {highlightCards.map((card, index) => (
            <article className="highlight-card" key={index}>
              <div className="highlight-card__image">
                <img src={card.image} alt={card.alt} loading="lazy" />
              </div>
              <div className="highlight-card__content">
                <h3>{card.title}</h3>
                <p>{card.caption}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
